// extracted by mini-css-extract-plugin
export var textInput = "_kf-0";